module.exports = __webpack_public_path__ + "static/match_icon.bc948ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/match_icon.png
// module id = 432
// module chunks = 35783957827783